import React, { FC } from "react";
import {Text} from "@wakelet/ui-kit";

type Props = {
  message: string
}

export const WakeletHeader: FC<Props> = ({message}) => {
  return <div className="flex flex-col w-full items-center mb-8" data-testid="wakelet-header">
    <img
        className="content-center mb-4 w-[114px] h-[27px]"
        src="https://assets.wakelet.com/logo/wklt-blue.svg"
        data-testid="login-form-logo"
        alt="wakelet"
    />
    <Text.Heading level={3} className="whitespace-pre-line text-center">{message}</Text.Heading>
  </div>
}
